import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SpinnerModule } from '@sag-ui';

@Component({
    selector: 'app-cod-submitting-step',
    templateUrl: './submitting.component.html',
    imports: [CommonModule, SpinnerModule],
    standalone: true
})
export class CodSubmittingStepComponent {}
